import { FC, Suspense } from 'react';
import { useAtomValue } from 'jotai';
import { ArticleCommentsSection } from './comment';
import { ArticleMainSections } from './main';
import { ArticleCampaignSection } from './campaign';
import { ArticleRelatedTopicSection } from './related-topic';
import { ArticleRelatedPostSection } from './related-post';
import { ArticleBodySkeleton, ArticleRecommendSkeleton } from '~/skeleton/article';
import { $HitCampaignPosterMoveDown } from '~/utils/libra/campaign-poster-remove';

export const ArticleBody: FC = () => {
  const hitCampaignPosterMoveDown = useAtomValue($HitCampaignPosterMoveDown);

  return (
    <>
      <ArticleMainSections />
      <Suspense fallback={<ArticleBodySkeleton />}>
        <ArticleCommentsSection />
        {!hitCampaignPosterMoveDown && <ArticleCampaignSection />}
        <Suspense fallback={<ArticleRecommendSkeleton />}>
          <ArticleRelatedPostSection />
          <ArticleRelatedTopicSection />
        </Suspense>
        {hitCampaignPosterMoveDown && <ArticleCampaignSection />}
      </Suspense>
    </>
  );
};
